<template>
  <v-app v-cloak>
    <div x-ms-format-detection="none" class="corpoConteudo conteudo" v-on:click.capture="$store.commit('setHoraEvento')" v-on:keyup.capture="$store.commit('setHoraEvento')">
      <v-content>
        <router-view></router-view>
      </v-content>
    </div>
  </v-app>
</template>

<script>
import Jquery from "jquery";
export default {
  name: "App",
  data() {//Declaracao de variaveis
    return {
    };
  },
  created() /*Metodo de start do componente*/{
  }
};

function ajustaTopo() {
  var rolagemY = Jquery(window).scrollTop();

  if (rolagemY > 70) {
    Jquery("#header, .header,.menuDrawer").addClass("ajustada");
  } else {
    Jquery("#header, .header,.menuDrawer").removeClass("ajustada");
  }
}
</script>


<style>
@import url("/css/fontes/gotham/css/gotham.css");
@import url("/css/geral.css");
@import url("/css/color.css");
@import url("/css/forms.css");
@import url("/css/paddings.css");
.corpoConteudo {
  width: 100%;
}
</style>

